const indices = [
  {
    title: '红桃视频专区',
    desc: '热门影视剧集与独家综艺节目',
    count: '3,286部',
    icon: 'ri-heart-pulse-line',
    color: 'primary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20film%20collection%20with%20soft%20red%20gradients%2C%20cinematic%20composition%2C%20elegant%20movie%20poster%20style%2C%20dramatic%20lighting%2C%20entertainment%20platform%20theme%2C%20rich%20warm%20atmosphere%2C%20professional%20design%2C%20no%20text&width=600&height=320&seq=idx-1&orientation=landscape',
  },
  {
    title: '西瓜视频精选',
    desc: '免费热播大片与经典影视回顾',
    count: '5,120部',
    icon: 'ri-movie-2-line',
    color: 'accent',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fresh%20summer%20cinema%20theme%20with%20green%20and%20gold%20accents%2C%20modern%20film%20strip%20elements%2C%20abstract%20play%20button%20design%2C%20warm%20ambient%20lighting%2C%20entertainment%20industry%20aesthetic%2C%20clean%20composition%2C%20no%20text&width=600&height=320&seq=idx-2&orientation=landscape',
  },
  {
    title: '小蓝视频热播',
    desc: '最新动漫番剧与日韩剧场更新',
    count: '2,845部',
    icon: 'ri-ancient-gate-line',
    color: 'secondary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cool%20toned%20abstract%20anime%20style%20background%20with%20soft%20blue%20and%20silver%20gradients%2C%20modern%20streaming%20platform%20design%2C%20digital%20entertainment%20theme%2C%20clean%20geometric%20elements%2C%20professional%20aesthetic%2C%20smooth%20gradients%2C%20no%20text&width=600&height=320&seq=idx-3&orientation=landscape',
  },
  {
    title: '茄子视频推荐',
    desc: '高分欧美大片与独立电影精选',
    count: '1,968部',
    icon: 'ri-emotion-happy-line',
    color: 'primary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20purple%20and%20gold%20cinematic%20abstract%20background%2C%20film%20reel%20elements%2C%20elegant%20movie%20theater%20atmosphere%2C%20soft%20dramatic%20lighting%2C%20premium%20entertainment%20branding%2C%20rich%20textures%2C%20no%20text&width=600&height=320&seq=idx-4&orientation=landscape',
  },
  {
    title: '久久视频经典',
    desc: '经典老片修复与怀旧影视合集',
    count: '4,502部',
    icon: 'ri-time-line',
    color: 'accent',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20film%20aesthetic%20with%20warm%20sepia%20and%20gold%20tones%2C%20classic%20cinema%20elements%2C%20nostalgic%20atmosphere%2C%20old%20Hollywood%20glamour%2C%20artistic%20film%20texture%2C%20elegant%20composition%2C%20no%20text&width=600&height=320&seq=idx-5&orientation=landscape',
  },
  {
    title: '芒果视频独家',
    desc: '独家自制综艺与原创剧集内容',
    count: '1,534部',
    icon: 'ri-vip-crown-line',
    color: 'secondary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20warm%20yellow%20and%20orange%20abstract%20background%2C%20modern%20variety%20show%20theme%2C%20energetic%20entertainment%20design%2C%20creative%20stage%20lighting%20elements%2C%20playful%20composition%2C%20premium%20production%20feel%2C%20no%20text&width=600&height=320&seq=idx-6&orientation=landscape',
  },
  {
    title: '纪录纪实频道',
    desc: 'BBC与NHK纪录片高清合集',
    count: '2,108部',
    icon: 'ri-earth-line',
    color: 'primary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Documentary%20style%20abstract%20with%20natural%20earth%20tones%2C%20world%20map%20elements%2C%20cinematic%20landscape%20feeling%2C%20professional%20documentary%20aesthetic%2C%20warm%20ambient%20lighting%2C%20clean%20modern%20design%2C%20no%20text&width=600&height=320&seq=idx-7&orientation=landscape',
  },
  {
    title: '综艺娱乐大全',
    desc: '国内外热门综艺节目每日更新',
    count: '3,975部',
    icon: 'ri-emotion-laugh-line',
    color: 'accent',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20abstract%20entertainment%20show%20theme%2C%20vibrant%20stage%20lighting%20design%2C%20dynamic%20composition%2C%20fun%20playful%20elements%2C%20modern%20variety%20program%20aesthetic%2C%20warm%20bright%20colors%2C%20no%20text&width=600&height=320&seq=idx-8&orientation=landscape',
  },
];

const colorIconMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-600',
  accent: 'bg-accent-100 text-accent-600',
  secondary: 'bg-secondary-100 text-secondary-600',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            主题索引
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
            视频频道专题合集
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            八大频道分类，覆盖影视综艺纪录片，满足不同口味观影需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indices.map((item) => (
            <a
              key={item.title}
              href="#carousel"
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="text-sm font-semibold text-background-50">{item.title}</h3>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className={`w-7 h-7 rounded-lg flex items-center justify-center ${colorIconMap[item.color]}`}>
                      <i className={`${item.icon} text-sm`}></i>
                    </div>
                    <p className="text-xs text-foreground-500">{item.desc}</p>
                  </div>
                  <span className="text-xs font-medium text-foreground-600 whitespace-nowrap ml-2">{item.count}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}